import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { AbsenceEmployee } from '@qaroni-app/absences/types/absence-employee';
import { format } from 'date-fns';

@Component({
  selector: 'qaroni-absence-confirmation-preview',
  templateUrl: './absence-confirmation-preview.component.html',
  styleUrls: ['./absence-confirmation-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AbsenceConfirmationPreviewComponent {
  readonly absense = input<AbsenceEmployee | null>(null);
  readonly type = input<'confirmation' | 'validation'>('confirmation');

  get showCheckIcon(): boolean {
    if (this.type() === 'confirmation') {
      const absense = this.absense();
      return absense?.confirm === true && !!absense?.confirmDate;
    } else {
      const absense = this.absense();
      return !!absense?.validatedBy && !!absense?.validationDate;
    }
  }

  get confirmationTooltip(): string {
    if (this.type() === 'confirmation') {
      const absense = this.absense();
      return absense?.confirm === true && absense?.confirmDate
        ? $localize`Confirmado el ` +
            format(new Date(absense.confirmDate), 'dd/MM/yyyy HH:mm')
        : '';
    } else {
      const absense = this.absense();
      return absense?.validatedBy && absense?.validationDate
        ? $localize`Validado por ${absense.validatedBy?.fullName} el ` +
            format(new Date(absense.validationDate), 'dd/MM/yyyy HH:mm')
        : '';
    }
  }
}
